import { t } from 'i18next';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export enum BadgeVariant {
  PURPLE = 'purple',
  YELLOW = 'yellow',
}
interface IBadgeProps {
  text: string;
  variant: BadgeVariant;
}

const Badge = ({ text = t('Default'), variant }: IBadgeProps) => {
  const containerClassName = twMerge(
    'w-fit',
    'h-fit',
    'p-1',
    'px-2',
    'rounded-3xl',
    'prose-body-sm-med',
    `${variant === BadgeVariant.PURPLE ? 'bg-violet-600 text-white' : ''}`,
    `${variant === BadgeVariant.YELLOW ? 'bg-kira-yellow-900' : ''}`
  );

  return <div className={containerClassName}>{text}</div>;
};

export default Badge;
